import { render, staticRenderFns } from "./GoalPlanner.vue?vue&type=template&id=05b0a32c"
import script from "./GoalPlanner.ts?vue&type=script&lang=ts&external"
export * from "./GoalPlanner.ts?vue&type=script&lang=ts&external"
import style0 from "./GoalPlanner.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports